import {
  isSessionInvalidationInProgress,
  claimExpiredRedirect,
} from "./sessionState";

/**
 * Factory that creates a guarded 401 redirect handler.
 *
 * Each app (admin, investor) calls this once at module scope, passing its
 * own Redux store and resetAuthState action creator. The returned function
 * can be called from Axios interceptors and React Query onError handlers.
 *
 * Guards (in order):
 * 1. Already on /login → no-op (don't redirect to self)
 * 2. Session-invalidation overlay in progress → no-op (different flow owns cleanup)
 * 3. Another 401 handler already claimed the redirect → no-op (prevents multiple reloads)
 */
export const createUnauthorizedRedirectHandler = (
  store: { dispatch: (action: any) => void },
  resetAuthState: () => { type: string }
): (() => void) => {
  return () => {
    if (window.location.pathname === "/login") return;
    if (isSessionInvalidationInProgress()) return;
    if (!claimExpiredRedirect()) return;

    store.dispatch(resetAuthState());
    sessionStorage.clear();
    sessionStorage.setItem("sessionExpired", "true");
    window.location.replace("/login");
  };
};
